"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.googleApiWrapper = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _commonLibs = require("@mmc/common-libs");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var googleApiWrapper = function googleApiWrapper(options) {
  return function (WrappedComponent) {
    var libraries = options.libraries || ['places', 'geometry'];
    var Wrapper = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(Wrapper, _Component);
      function Wrapper(props, context) {
        var _this;
        _this = _Component.call(this, props, context) || this;
        _this.state = {
          loaded: false,
          google: null
        };
        return _this;
      }

      // eslint-disable-next-line camelcase, react/sort-comp
      var _proto = Wrapper.prototype;
      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _this$props = this.props,
          newApiKey = _this$props.newApiKey,
          region = _this$props.region,
          language = _this$props.language;
        this.scriptCache = (0, _commonLibs.loadScript)({
          google: (0, _commonLibs.getGoogleApiURL)({
            apiKey: newApiKey,
            libraries: libraries,
            region: region || null,
            language: language || null
          })
        });
      };
      _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this.scriptCache.google.onLoad(function () {
          // eslint-disable-next-line global-require
          require('../vendor/v3-utility-library/richmarker');
          // eslint-disable-next-line global-require
          require('../vendor/v3-utility-library/markerclusterer');
          _this2.setState({
            loaded: true,
            google: window.google
          });
        });
      };
      _proto.render = function render() {
        var _this$state = this.state,
          loaded = _this$state.loaded,
          google = _this$state.google;
        var props = _objectSpread(_objectSpread({}, this.props), {}, {
          loaded: loaded,
          google: google
        });
        var style = {
          width: '100%',
          height: '100%',
          display: 'block',
          minHeight: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style
        }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props));
      };
      return Wrapper;
    }(_react.Component);
    return Wrapper;
  };
};
exports.googleApiWrapper = googleApiWrapper;
var _default = googleApiWrapper;
exports["default"] = _default;